import React from "react";

function wrapWithCloser(clickHandler) {

  return (WrappedComponent) => React.cloneElement(WrappedComponent, {...WrappedComponent.props, onClick: clickHandler});

}

export default wrapWithCloser;
